import { Col, DatePicker, Form, Row } from 'antd';
import { useForm } from 'antd/es/form/Form';
import {
  Dispatch,
  SetStateAction,
  useEffect,
  useImperativeHandle,
  useState,
  forwardRef,
} from 'react';

import { FormFilter, SelectForm } from 'components';
import { IPlant } from 'interfaces/Plant/Plant';
import Content from 'layouts/Content';
import dayjs from 'dayjs';
import { useMutation } from '@tanstack/react-query';
import { PlantApi } from 'apis/PlantApis';
import { useUser } from 'contexts/UserProvider';

interface IProps {
  plants: IPlant[];
  isOpenFilter: boolean;
  onFinish: (values: any) => void;
  setIsOpenFilter: Dispatch<SetStateAction<boolean>>;
}

const spanCol = 8;

const FilterHOPlan = forwardRef(
  ({ plants, isOpenFilter, onFinish, setIsOpenFilter }: IProps, ref) => {
    const { user } = useUser();
    const [form] = useForm();

    const [typeRevenue, setTypeRevenue] = useState([{}]);

    const onCancel = () => {
      const fields = form.getFieldsValue();

      if (user?.isCN) {
        form.resetFields(['year']);
        onFinish({ branch: fields.branch });
        return;
      }

      onFinish({});
      form.resetFields();
    };

    useEffect(() => {
      form.setFieldValue(
        'year',
        dayjs(new Date().getFullYear().toString(), 'YYYY'),
      );
      user?.isCN && form.setFieldValue('branch', user?.plantCode);
      getTypeRevenue();
    }, []);

    useImperativeHandle(ref, () => ({
      resetFields: () => {
        onFinish({});
        form.resetFields();
      },
      setFieldValue: (name: any, value: any) => {
        form.setFieldValue(
          name,
          name === 'year' ? dayjs(value?.toString(), 'YYYY') : value,
        );
      },
    }));

    const { mutate: getTypeRevenue } = useMutation({
      mutationFn: () => PlantApi.getTypeRevenueComboBox(),
      onSuccess: (res: any) => {
        setTypeRevenue(
          res.data.getCode.items
            ? res.data.getCode.items.map((item: any) => ({
                value: item.id,
                label: item.name,
              }))
            : [],
        );
      },
      onError: (error) => {
        return console.log(error);
      },
    });

    return (
      <Content isOpen={isOpenFilter}>
        <FormFilter form={form} onFinish={onFinish} onCancel={onCancel}>
          <Row gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
            <Col span={spanCol} className="h-[80px]">
              <Form.Item label="Năm" name="year">
                <DatePicker
                  picker="year"
                  className="w-full h-[40px]"
                  placeholder="Chọn năm"
                />
              </Form.Item>
            </Col>
            <Col span={spanCol} className="h-[80px]">
              <Form.Item label="Loại doanh thu" name="typeRevenue">
                <SelectForm
                  className="w-full h-[40px]"
                  placeholder="Chọn loại doanh thu"
                  options={typeRevenue}
                />
              </Form.Item>
            </Col>
            <Col span={spanCol} className="h-[80px]">
              <Form.Item label="Chi nhánh" name="branch">
                <SelectForm
                  disabled={user?.isCN}
                  placeholder="Chọn chi nhánh"
                  options={plants.map((plant) => ({
                    label: plant.id,
                    value: plant.id,
                  }))}
                />
              </Form.Item>
            </Col>
          </Row>
        </FormFilter>
      </Content>
    );
  },
);

export default FilterHOPlan;
